<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-demo__scopecity">
       
        
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.name" placeholder="请输入合作机构名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.contactMobile" placeholder="请输入联系人手机号" clearable></el-input>
        </el-form-item>
       
       
         
          <el-form-item>
            <el-button @click="getDataList()">{{ $t('query') }}</el-button>
          </el-form-item>
  <!--        <el-form-item>-->
  <!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
  <!--        </el-form-item>-->
          <el-form-item>
            <el-button  v-if="$hasPermission('wx:cooperativeagency:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
          </el-form-item>
     
        </el-form>
        
        <el-table  v-loading="dataListLoading" :data="dataList" border style="width: 100%;">
          <el-table-column prop="name" label="合作机构名称" header-align="center" align="center"></el-table-column>
          <el-table-column prop="contactName" label="联系人姓名" header-align="center" align="center"></el-table-column>
          <el-table-column prop="contactMobile" label="联系人手机号" header-align="center" align="center"></el-table-column>
          <el-table-column prop="bdPm" label="BD/PM" header-align="center" align="center"></el-table-column>
          <el-table-column prop="invitationCode" label="邀请码" header-align="center" align="center"></el-table-column>
          <el-table-column prop="createDate" label="注册时间" header-align="center" align="center"></el-table-column>
         
          <!-- <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-button v-if="$hasPermission('sys:scopecity:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
              <el-button v-if="$hasPermission('sys:scopecity:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <!-- <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination> -->
      </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
  import AddOrUpdate from './cooperativeagency-add-or-update.vue'

  export default {
    mixins: [mixinViewModule],
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/sys/mechanism/list',
          getDataListIsPage: false,
          exportURL: '/sys/scopecity/export',
          deleteURL: '/sys/scopecity',
          deleteIsBatch: true
        },
        filterText:'',
        citys:[],
        pages:[],
        pageList: [{
            label: '落地页1',
            children: [
              {
               label: '上海',
             },
             {
               label: '北京',
             },
           ]
          }],
  
          defaultProps: {
            children: 'children',
            label: 'label',
            
          },
  
        strategys:[
          // {
          //   'label':'顺序',
          //   'value':1,
          // },
          {
            'label':'轮询',
            'value':1,
          },
          {
            'label':'随机',
            'value':2,
          }
        ],
        dataForm: {
          pageId: '',
          city: '',
          strategy:''
        }
      }
    },
    components: {
      AddOrUpdate
    },
    created () {
      if (this.mixinViewModuleOptions.createdIsNeed) {
        this.query()
        this.getCityOptions();
        this.getPageOptions();
      }
    },
    computed:{
      getPageList(){
        return this.dataList.map(item => {
          return {
            label: item.pageName,
            ...item,
            children: [
            ...item.city.split(',').map(item1 => ({ label: item1, city: item.city, pageName: item.pageName, id: item.id})),
           ]
          }
        })
      }
    },
  
    methods: {
    
    
      
      //初始化下拉框中的选项
      async getCityOptions() {
        this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.citys=[];
          if (res.data!=null){
            res.data.forEach(element => {
              this.citys.push({label:element.dictLabel,value:element.dictValue})
            })
          }
        }).catch(() => {})
      },
      //初始化落地页下拉框中的选项
      async getPageOptions() {
        this.$http.get(`/sys/landingpages/list`).then(({ data: res }) => {
         
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.pages=[];
          if (res.data!=null){
            res.data.forEach(element => {
              this.pages.push({label:element.name,value:element.id})
            })
          }
        }).catch(() => {})
      },
    
    }
  }
  </script>
  <style scoped lang="scss">
  
  
  </style>
  